import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Calendar, { CalendarEvent } from "components/Calendar/GlobalCalendar"; import AppPage from "layouts/AppPage";
import useNavbar from "hooks/useNavbar";

export default function CalendarPage() {
  const { setPageTitle } = useNavbar();
  useEffect(() => {
    setPageTitle("Calendar Test");
  }, [setPageTitle]);

  const [events, setEvents] = useState<CalendarEvent[]>([{
    id: "1",
    title: "Team Sync",
    start: new Date(new Date().setHours(9, 0, 0, 0)),
    end: new Date(new Date().setHours(10, 0, 0, 0)),
  }, {
    id: "2",
    title: "1:1 with Jane",
    start: new Date(new Date().setHours(9, 30, 0, 0)),
    end: new Date(new Date().setHours(10, 15, 0, 0)),
  }, {
    id: "3",
    title: "Lunch",
    start: new Date(new Date().setHours(12, 0, 0, 0)),
    end: new Date(new Date().setHours(13, 0, 0, 0)),
  }]);

  const handleUpdate = (id: string, newStart: Date, newEnd: Date) => {
    setEvents((prev) => prev.map((e) => (e.id === id ? { ...e, start: newStart, end: newEnd } : e)));
  };

  const handleCreate = (start: Date, end: Date) => {
    const id = Math.random().toString(36).substring(2, 9);
    setEvents((prev) => [...prev, { id, title: "New Event", start, end }]);
  };

  const startDate = new Date();
  startDate.setHours(0, 0, 0, 0);

  return (
    <AppPage>
      <Box p={4}>
        <Calendar
          events={events}
          onUpdate={handleUpdate}
          onCreate={handleCreate}
          startDate={startDate}
        />
      </Box>
    </AppPage>
  );
}
